(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barraofertas"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pa-oferta]').forEach(function (barra) {
    var timer = barra.querySelector('[data-pa-oferta-timer]');
    var minutos = parseInt(barra.getAttribute('data-minutos'), 10) || 10;
    var total = minutos * 60;
    var restante = total;
    function pintar() {
      var m = Math.floor(restante / 60);
      var s = restante % 60;
      timer.textContent = (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    }
    pintar();
    setInterval(function () {
      restante = restante > 0 ? restante - 1 : total;
      pintar();
    }, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineatiempo"] && !Shopify.designMode) return;
  try {
    
(function() {
  function activarAnimacion(seccion) {
    var items = seccion.querySelectorAll('.circulacion-timeline-item');
    if (!('IntersectionObserver' in window)) {
      return;
    }
    var observador = new IntersectionObserver(function(entradas) {
      entradas.forEach(function(entrada) {
        if (entrada.isIntersecting) {
          entrada.target.style.opacity = '1';
          entrada.target.style.transform = 'translateY(0)';
          observador.unobserve(entrada.target);
        }
      });
    }, { threshold: 0.2 });
    items.forEach(function(item) {
      if (item.getAttribute('data-animado') === 'true') {
        return;
      }
      item.setAttribute('data-animado', 'true');
      item.style.opacity = '0';
      item.style.transform = 'translateY(16px)';
      item.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observador.observe(item);
    });
  }

  document.querySelectorAll('.circulacion-timeline-seccion').forEach(function(seccion) {
    activarAnimacion(seccion);
  });

  document.addEventListener('shopify:section:load', function() {
    document.querySelectorAll('.circulacion-timeline-seccion').forEach(function(seccion) {
      activarAnimacion(seccion);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccioningredientes"] && !Shopify.designMode) return;
  try {
    
(function() {
  function inicializarCarrusel(seccion) {
    var pista = seccion.querySelector('.ingredientes-trabajan-pista');
    var slides = seccion.querySelectorAll('.ingredientes-trabajan-slide');
    var botonAnterior = seccion.querySelector('.ingredientes-trabajan-boton-anterior');
    var botonSiguiente = seccion.querySelector('.ingredientes-trabajan-boton-siguiente');
    if (!pista || slides.length === 0) {
      return;
    }
    var indice = 0;
    var total = slides.length;

    function actualizar() {
      pista.style.transform = 'translateX(-' + (indice * 100) + '%)';
    }

    if (botonSiguiente) {
      botonSiguiente.addEventListener('click', function() {
        indice = (indice + 1) % total;
        actualizar();
      });
    }
    if (botonAnterior) {
      botonAnterior.addEventListener('click', function() {
        indice = (indice - 1 + total) % total;
        actualizar();
      });
    }

    var inicioX = 0;
    pista.addEventListener('touchstart', function(evento) {
      inicioX = evento.touches[0].clientX;
    }, { passive: true });
    pista.addEventListener('touchend', function(evento) {
      var finX = evento.changedTouches[0].clientX;
      var diferencia = inicioX - finX;
      if (Math.abs(diferencia) > 40) {
        if (diferencia > 0) {
          indice = (indice + 1) % total;
        } else {
          indice = (indice - 1 + total) % total;
        }
        actualizar();
      }
    }, { passive: true });

    actualizar();
  }

  document.querySelectorAll('.ingredientes-trabajan-seccion').forEach(function(seccion) {
    inicializarCarrusel(seccion);
  });

  document.addEventListener('shopify:section:load', function() {
    document.querySelectorAll('.ingredientes-trabajan-seccion').forEach(function(seccion) {
      inicializarCarrusel(seccion);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
